export function mentionItemRendererWithAvatar (item) {
    const itemElement = document.createElement('span');

    itemElement.classList.add('mention-item');
    itemElement.id = `mention-list-item-id-${item.id}`;
    itemElement.textContent = `${item.name} `;

    return itemElement;
}

export function mentionCustomization (editor) {
    editor.conversion.for('downcast').attributeToElement({
        model: 'mention',
        view: (modelAttributeValue, { writer }) => {
            if (!modelAttributeValue) {
                return;
            }

            return writer.createAttributeElement('span', {
                class: 'mention',
                'data-mention': modelAttributeValue.id,
                'data-mentioned-user-id': modelAttributeValue.userId,
            }, {
                priority: 20,
                id: modelAttributeValue.uid,
            });
        },
        converterPriority: 'high',
    });
}
